<template>
  <v-dialog v-model="show" max-width="600" scrollable>
    <v-card>
      <v-toolbar dense dark color="blue darken-2">
        <v-toolbar-title class="text-body-2 font-weight-bold">
          Prode de {{ nombreParticipante }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-2" style="max-height: 500px;">
        <!-- Selector de grupo -->
        <div class="d-flex flex-wrap justify-center mb-2" style="gap: 4px;">
          <v-btn
            v-for="grupo in grupos"
            :key="grupo"
            :color="grupoActivo === grupo ? 'blue darken-2' : 'grey lighten-2'"
            :dark="grupoActivo === grupo"
            x-small depressed
            style="min-width: 28px; padding: 0 5px; font-size: 0.65rem; font-weight: 700;"
            @click="grupoActivo = grupo"
          >
            {{ grupo }}
          </v-btn>
        </div>

        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-right">Equipo 1</th>
              <th class="text-center" style="width: 70px;">Pronóstico</th>
              <th>Equipo 2</th>
              <th class="text-center" style="width: 70px;">Real</th>
              <th class="text-center" style="width: 40px;">Pts</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, idx) in partidosGrupo" :key="idx">
              <td class="text-right text-caption">{{ p.equipo1 }}</td>
              <td class="text-center font-weight-bold">
                {{ p.goles1 !== '' && p.goles1 !== null ? p.goles1 + ' - ' + p.goles2 : '-' }}
              </td>
              <td class="text-caption">{{ p.equipo2 }}</td>
              <td class="text-center font-weight-bold">
                <span v-if="p.goles1Real !== null && p.goles1Real !== ''">
                  {{ p.goles1Real }} - {{ p.goles2Real }}
                </span>
                <span v-else class="grey--text">-</span>
              </td>
              <td class="text-center">
                <v-chip x-small :color="colorPuntos(p.puntos)" dark style="font-size: 0.65rem; height: 18px;">
                  {{ p.puntos !== null && p.puntos !== undefined ? p.puntos : '-' }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-2">
        <v-chip small color="blue darken-1" dark>
          Total: {{ totalPuntos }} pts
        </v-chip>
        <v-spacer />
        <v-btn small text @click="show = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "../../../axios-auth";

export default {
  name: "Informe2026",
  props: ["visible", "legajo"],

  data() {
    return {
      grupos: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      grupoActivo: "A",
      partidos: [],
      nombreParticipante: "",
    };
  },

  computed: {
    show: {
      get() {
        if (this.visible) this.cargarDatos();
        return this.visible;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },

    partidosGrupo() {
      return this.partidos.filter((p) => p.grupo === this.grupoActivo);
    },

    totalPuntos() {
      return this.partidos.reduce((sum, p) => sum + (p.puntos || 0), 0);
    },
  },

  methods: {
    cargarDatos() {
      if (!this.legajo) return;

      axios
        .get("/App/GetProdeLegajo2026", { params: { filtrolegajo: this.legajo } })
        .then((r) => {
          this.partidos = r.data || [];
          if (this.partidos.length > 0 && this.partidos[0].nombre) {
            this.nombreParticipante = this.partidos[0].nombre;
          }
        })
        .catch(() => { this.partidos = []; });
    },

    colorPuntos(pts) {
      if (pts === null || pts === undefined) return "grey";
      if (pts >= 3) return "green darken-1";
      if (pts > 0) return "orange darken-1";
      return "red darken-1";
    },
  },
};
</script>
